import { LazyExoticComponent, JSX, lazy } from "react";

type RouteConfig = {
  key: string;
  path: string;
  element: LazyExoticComponent<() => JSX.Element>;
  isProtected?: boolean;
  isAdmin?: boolean;
  meta?: {
    layout?: "sidebar-classic" | "top-bar-classic" | "blank";
  }
}

export const routesConfig: RouteConfig[] = [
  {
    key: "home-redirect",
    path: "/",
    element: lazy(() => import('../../views/WorkspaceHomeRedirect')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "home",
    path: "/workspace/:workspaceId",
    element: lazy(() => import('../../views/Home')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "data",
    path: "/data",
    element: lazy(() => import('../../views/Datasets')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "galleries",
    path: "/galleries",
    element: lazy(() => import('../../views/Galleries')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "boards",
    path: "/boards",
    element: lazy(() => import('../../views/Boards')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "boards-detail",
    path: "/boards/:boardId",
    element: lazy(() => import('../../views/BoardDetail')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  // More specific /workflows* paths first (resolveRouteLayout + matchPath).
  {
    key: "workflows-detail",
    path: "/workflows/:workflowId",
    element: lazy(() => import('../../views/WorkflowDetail')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "workflows",
    path: "/workflows",
    element: lazy(() => import('../../views/Workflows')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: "profile",
    path: "/profile",
    element: lazy(() => import('../../views/Profile')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' }
  },
  {
    key: 'data-detail',
    path: '/data/:id',
    element: lazy(() => import('../../views/DataDetail')),
    isProtected: true,
    meta: { layout: 'sidebar-classic' },
  },
  {
    key: "admin",
    path: "/admin",
    element: lazy(() => import('../../views/Admin')),
    isProtected: true,
    isAdmin: true,
    meta: { layout: 'top-bar-classic' } 
  },
  {
    key: "sign-up",
    path: "/sign-up",
    element: lazy(() => import('../../views/SignUp')),
    isProtected: false,
    meta: { layout: 'blank' } 
  },
  {
    key: "sign-in",
    path: "/sign-in",
    element: lazy(() => import('../../views/SignIn')),
    isProtected: false,
    meta: { layout: 'blank' } 
  },
  {
    key: "not-found",
    path: "/not-found",
    element: lazy(() => import('../../views/NotFound')),
    isProtected: true,
    meta: { layout: 'blank' } 
  },
  {
    key: 'privacy',
    path: '/privacy',
    element: lazy(() => import('../../views/Privacy')),
    isProtected: false,  
    meta: { layout: 'blank' }
  },
  {
    key: 'public-gallery',
    path: '/gallery/:token',
    element: lazy(() => import('../../views/PublicGallery')),
    isProtected: false,
    meta: { layout: 'blank' }
  },
  {
    key: 'verify-email',
    path: '/verify-email',
    element: lazy(() => import('../../views/VerifyEmail')),
    isProtected: false,
    meta: { layout: 'blank' }
  },
  {
    key: 'forgot-password',
    path: '/forgot-password',
    element: lazy(() => import('../../views/ForgotPassword')),
    isProtected: false,
    meta: { layout: 'blank' }
  },
  {
    key: 'forgot-password-sent',
    path: '/forgot-password/sent',
    element: lazy(() => import('../../views/ForgotPasswordSent')),
    isProtected: false,
    meta: { layout: 'blank' }
  },
  {
    key: 'reset-password',
    path: '/reset-password',
    element: lazy(() => import('../../views/ResetPassword')),
    isProtected: false,
    meta: { layout: 'blank' }
  }
];
